import { Tracker } from 'services/tracking';
import {
  HOSTED_PAGE_TYPES,
  GA_CATEGORIES,
  GA_ACTIONS,
  DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME,
  GA_LABEL,
  FS_CATEGORIES,
  FS_ACTIONS,
  FS_LABEL
} from 'consts';

const tracker = new Tracker(HOSTED_PAGE_TYPES.checkout);

export const trackCheckoutPageLoadSavedCard = numberOfCards => {
  tracker.fireEvent({
    category: JSON.stringify({
      [GA_CATEGORIES.NUMBER_OF_CARDS]: numberOfCards
    }),
    action: GA_ACTIONS.PAGE_LOAD_SAVED_CARDS
  });
};

export const trackAddNewCard = () => {
  tracker.fireEvent({
    category: GA_ACTIONS.ADD_NEW_CARD,
    action: GA_ACTIONS.ADD_NEW_CARD
  });
};

export const trackExpandHeader = expanded => {
  const category = expanded ? 'Collapse' : 'Expand';
  tracker.fireEvent({
    category,
    action: GA_ACTIONS.PAYMENT_SUMMERY
  });
};

export const trackReusableLinkSubmit = ({ gaLabel, isError = false }) => {
  tracker.fireEvent({
    category: GA_CATEGORIES.PAYMENT_LINK_SUBMIT,
    action: isError
      ? `${GA_CATEGORIES.PAYMENT_LINK_SUBMIT} + ${GA_ACTIONS.FAILURE} `
      : `${GA_CATEGORIES.PAYMENT_LINK_SUBMIT} + ${GA_ACTIONS.SUCCESS}`,
    label: gaLabel
  });
};

export const trackPaymentSuccess = ({ digitalWalletProvider } = {}) => {
  tracker.fireEvent(
    {
      category: GA_CATEGORIES.PAYMENT_SUBMIT,
      action: GA_CATEGORIES.PAYMENT_SUBMIT,
      label: JSON.stringify({
        message: GA_LABEL.PAYMENT_SUCCESS,
        status: GA_LABEL.SUCCESS,
        [GA_LABEL.DIGITAL_WALLET]:
          DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME[digitalWalletProvider] || null
      })
    },
    {
      category: FS_CATEGORIES.PAYMENT_SUBMIT,
      action: FS_ACTIONS.SUCCESS,
      label: FS_LABEL.PAYMENT_SUCCESS
    }
  );
};

export const trackPaymentFail = ({ error, digitalWalletProvider = '' }) => {
  tracker.fireEvent(
    {
      category: GA_CATEGORIES.PAYMENT_SUBMIT,
      action: GA_CATEGORIES.PAYMENT_SUBMIT,
      label: JSON.stringify({
        status: GA_LABEL.FAILURE,
        [GA_LABEL.DIGITAL_WALLET]:
          DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME[digitalWalletProvider] || null,
        code: error.response?.data.status.error_code,
        message: error.response?.data.status.message
      })
    },
    {
      category: FS_CATEGORIES.PAYMENT_SUBMIT,
      action: FS_ACTIONS.FAILURE,
      label: JSON.stringify({
        code: error.response?.data.status.error_code,
        message: error.response?.data.status.message
      })
    }
  );
};

export const trackPaymentFailOnClick = (errorMessages = []) => {
  const stringifiedErrorMessages = errorMessages?.length
    ? JSON.stringify(errorMessages)
    : '';

  tracker.fireEvent(
    {
      category: GA_CATEGORIES.PAYMENT_SUBMIT,
      action: GA_CATEGORIES.PAYMENT_SUBMIT,
      label: JSON.stringify({
        status: GA_LABEL.FAILURE,
        message: GA_LABEL.FORM_NOT_VALID
      })
    },
    {
      category: FS_CATEGORIES.PAYMENT_SUBMIT,
      action: FS_ACTIONS.FAILURE,
      label: `${FS_LABEL.FORM_NOT_VALID} - ${stringifiedErrorMessages}`
    }
  );
};

export const trackPdfDownloadClick = () => {
  tracker.fireEvent({
    category: GA_CATEGORIES.THANK_YOU,
    action: 'PdfDownloadClick',
    label: 'Download'
  });
};

export const trackFinishClick = ({ isReusable }) => {
  tracker.fireEvent({
    category: GA_CATEGORIES.THANK_YOU,
    action: `FinishClick - ${
      isReusable ? GA_ACTIONS.MAKE_ANOTHER_PAYMENT : GA_ACTIONS.FINISH
    }`
  });
};

export const trackSdkParam = (category, action, value = '') => {
  tracker.fireEvent({
    category,
    action,
    label: value.toString()
  });
};
